import { Component }                 from '@angular/core';
import { ActivatedRoute }            from '@angular/router';
import { ArchivingErs }              from '@app/modules/archiving/models/archiving-ers.model';
import { ArchivingImportService }    from '@app/modules/archiving/services/archiving-import.service';
import {
	IBaseHttpParams,
	RequestCompleteListState
}                                    from '@core/interfaces/api.interface';
import { SelectFilterBaseComponent } from '@shared/list-operations/components/select-filters/select-filter-base/select-filter-base.component';
import { ISelectFilterable }         from '@shared/list-operations/model/filter.model';
import {
	Observable,
	of
}                                    from 'rxjs';

@Component( {
	selector: 'app-select-filter-archiving-ers',
	templateUrl: './../select-filter-base/select-filter-base.component.html'
} )

export class SelectFilterArchivingErsComponent extends SelectFilterBaseComponent implements ISelectFilterable {

	constructor(
		private readonly archivingImportService: ArchivingImportService,
		private readonly activatedRoute: ActivatedRoute
	) {
		super();
	}

	searchRequestCallback = ( searchRequestParams: IBaseHttpParams ): Observable<RequestCompleteListState<ArchivingErs>> => {
		const businessPremisesId = this.activatedRoute.snapshot.params?.businessPremisesId;
		if ( businessPremisesId ) {
			return this.archivingImportService.searchArchivingErsByBusinessPremisesId(
				businessPremisesId,
				searchRequestParams
			);
		}

		return of( this.getNotAskedRequestCompleteListState<ArchivingErs>() );
	};
}
